import { Accordion } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import FaqItem from "./FaqItem";

const Faq: FC = () => {
  const {
    state: { faq, selectedFaq },
    send,
  } = useRewardCenter();

  const handleValueChange = (value: string) =>
    send("rewardCenter", {
      type: "toggleFaq",
      id: value || (selectedFaq ?? ""),
    });

  return (
    <Accordion
      type="single"
      collapsible
      value={selectedFaq ?? ""}
      onValueChange={handleValueChange}
      data-slot="faq"
      className="gap-1.5"
    >
      {faq?.map((item) => (
        <FaqItem key={item.id} id={item.id} />
      ))}
    </Accordion>
  );
};

export default Faq;
